export default "__VITE_ASSET__0$Zzy1CX__"